/**
 * Dashboard
 */
import { Container, Typography } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import { UserContext } from "../contexts/configContext";
import DownloadFile from "./DownloadFile";
import PageTop from "./PageTop";
import QuoteTable from "./QuoteTable";
import UploadFile from "./UploadFile";

export default function Dashboard() {
  const user = useContext(UserContext);

  useEffect(() => {});

  return (
    <>
      <Container component="main" maxWidth="xl">
        <div>
          <Typography component="h1" variant="h5">
            <PageTop />
          </Typography>
          <UploadFile />
          <DownloadFile />
        </div>

        <QuoteTable />
      </Container>
    </>
  );
}
